module.exports = __webpack_public_path__ + "img/bevilacqua.a3539811.png";